module.exports = __webpack_public_path__ + "img/major6.d4a773ab.png";